
document.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('.hero');
  if (hero) {
    const form = hero.querySelector('form');
    if (form) {
      const googleAutocomplete = form.querySelector('#js-google-autocomplete-result');
      googleAutocomplete.addEventListener('change', () => {
        form.submit();
      });
    }
  }
});
